<template>
  <div id="observation" class="fixed-content">
    <page-section :header="require('@/assets/demo.jpg')"
                title="L'observation des pratiques 2026">
      <div class="row feature-block-row">
        <div class="col-md-3" />
        <feature-block v-for="(b, k) in texts.observation"
                       class="col-md-2 col-sm-4 col-xs-6"
                       :key="k" :title="b.title" :subtitle="b.subtitle"
                       :text="b.text" :icon="b.icon">
        </feature-block>
      </div>
    </page-section>
    <page-section type="dark-base"
                  title="3 actions">
      <div class="row">
        <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
          <div class="panel panel-observa4">
            <div class="panel-heading text-center">
              <h2 class="panel-title">
                <strong>OBSERVA4</strong>
              </h2>
              <h4>
                Observation des pratiques concernant la préparation cutanée avant
                la pose d'un cathéter, une manipulation d'un dispositif
                intra-vasculaire ou la réfection d'un pansement de cathéter
                central
              </h4>
            </div>
            <div class="panel-body">
              <ul>
                <horizontal-feature-block v-for="(b, k) in texts.observa4"
                                          :key="k" :title="b.title"
                                          :texts="b.texts" class="hfb-observa4"
                                          :icon="b.icon">
                </horizontal-feature-block>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-offset-2 col-md-offset-0 col-sm-8 col-md-4">
          <div class="panel panel-reaExplaur">
            <div class="panel-heading text-center">
              <h2 class="panel-title"><strong>RÉA expl AUR</strong></h2>
              <h4>
                <i>S. aureus</i> et prévention des bactériémies liées
                aux dispositifs invasifs dans les services
                de réanimation et en unités de soins continus
              </h4>
            </div>
            <div class="panel-body">
              <ul>
                <horizontal-feature-block v-for="(b, k) in texts.reaExplaur"
                                          :key="k" :title="b.title"
                                          class="hfb-reaExplaur" :texts="b.texts"
                                          :icon="b.icon">
                </horizontal-feature-block>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
          <div class="panel panel-spy4">
            <div class="panel-heading text-center">
              <h2 class="panel-title">
                <strong>SPY4</strong>
              </h2>
              <h4>
                Étude un jour donné de la prévalence du port des cathéters et
                de l'utilisation des MIDlines et des CVPs courts
              </h4>
            </div>
            <div class="panel-body">
              <ul>
                <horizontal-feature-block v-for="(b, k) in texts.spy4"
                                          :key="k" :title="b.title"
                                          :texts="b.texts" class="hfb-spy4"
                                          :icon="b.icon">
                </horizontal-feature-block>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </page-section>
    <page-section title="Téléchargements">
      <downloads />
    </page-section>
  </div>
</template>

<script>
import downloads from '@/components/observation/downloads'
import pageSection from '@/components/pagesection'
import featureBlock from '@/components/featureBlock'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import sc from '@/sc/presentation'
import { mapGetters } from 'vuex'

export default {
  name: 'observation',

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    }),

    texts: function () {
      return sc.texts
    },

    files: function () {
      return sc.files
    }
  },

  components: {
    'downloads': downloads,
    'feature-block': featureBlock,
    pageSection,
    'horizontal-feature-block': horizontalFeatureBlock
  },

  methods: {
    add () {
      this.$router.push('establishments')
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.feature-block-row {
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
        .col-sm-4:nth-child(4n+1) {
            clear: both;
        }
    }
}

.feature-block {
    margin-bottom: 10rem;
}

ul {
    padding-left: 1rem;
    padding-right: 1rem;
}

h2.panel-title {
    font-size: 180%;
}
</style>
